export default __webpack_public_path__ + "static/media/clock_fMT.b2c840d8.svg";